import { generateSrcSet } from '@core/Components/HeycarImage/GenerateSrcSet';
import { heycarLoader } from '@core/Components/HeycarImage/HeycarLoader';
import { IMAGE_SIZES, SRC_SET_WIDTHS } from '@core/Constants/ImageCarousel.constants';
import type { Tenant } from '@core/Entities/App/Tenants.entity';
import type { VehicleImage } from '@core/Entities/Vehicle/VehicleImage.entity';
import { getImgLoader } from '@core/Utils/Image/GetImgLoader';
import { purchaseProNativeRatioLoader } from '@shared-components/PpImage/Utils/PurchaseProLoader';

type Props = {
  currentIndex: number;
  images: VehicleImage[];
  tenant?: Tenant;
};

export const PatchworkGalleryPreloadLinks = ({ currentIndex, images, tenant }: Props) => {
  const size = tenant === 'purchasePro' ? 'pdpPurchaseProSlideshow' : 'largest';
  const defaultLoader = tenant === 'purchasePro' ? purchaseProNativeRatioLoader : heycarLoader;
  const widths = SRC_SET_WIDTHS[size];
  const preloadWidth = widths?.[0] ?? 565;
  const preloadImages = [currentIndex - 1, currentIndex, currentIndex + 1]
    .filter(index => index >= 0 && index < images.length)
    .map(index => images[index]);

  return preloadImages.map(image => {
    const loadr = getImgLoader(image, defaultLoader);

    return (
      <link
        key={`slideshow-preload-${image.url}`}
        rel="preload"
        as="image"
        fetchPriority="low"
        href={loadr({ src: image.url, width: preloadWidth })}
        imageSrcSet={generateSrcSet(image.url, loadr, widths)}
        imageSizes={IMAGE_SIZES[size]}
      />
    );
  });
};
